// DatePicker localization imports
import { registerLocale } from 'react-datepicker';
import el from 'date-fns/locale/el';
import ie from 'date-fns/locale/en-IE';
import { LANGUAGE_CODES } from 'Douleutaras/constants/system';

// DatePicker localization registration
// Cyprus (el-CY) uses Greek — date-fns has no dedicated Cyprus locale, and
// 'date-fns/locale/cy' is Welsh (ISO 639-1 "cy"), not Cyprus, so it must not
// be used here.
registerLocale(LANGUAGE_CODES.EL, el);
registerLocale(LANGUAGE_CODES.EL_CY, el);
registerLocale(LANGUAGE_CODES.EN_IE, ie);
